<template>
  <Common>
    <template #transport> 
      <h2>{{$t('track.trackWay.kazakhstan.h2')}}</h2>
      <p>{{$t('track.trackWay.kazakhstan.p1')}}</p> 
      <p>{{$t('track.trackWay.kazakhstan.p2')}}</p>
    </template>

    <!-- <template #pay>
      <h3>{{$t('track.trackWay.kazakhstan.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.kazakhstan.pay.p1')}}<br/>
        {{$t('track.trackWay.kazakhstan.pay.p2')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";
export default {
  components: { Common },
};
</script>

<style>
</style>